export const hoverStyle = {
    display: 'none',
    position: 'fixed',
    border: '1px solid #dbdbe4',
    color: '#fff',
    zIndex: 10000000,
    boxShadow: '0px 0px 5px 5px rgba(0, 0, 0, 0.05)'

}